import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulevartSettingsComponent } from './bulevart-settings.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { CategoriesModule } from './categories/categories.module';
import { SubcategoriesModule } from './subcategories/subcategories.module';
import { TertiaryCategoriesModule } from './tertiary-categories/tertiary-categories.module';


@NgModule({
    declarations: [
        BulevartSettingsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        CategoriesModule,
        SubcategoriesModule,
        TertiaryCategoriesModule
    ],
    exports: [BulevartSettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BulevartSettingsModule { }
